import DesktopFeaturesPage from 'components/features-page/DesktopFeaturesPage'
import type { PageProps } from 'gatsby'

export default function Windows({ location }: PageProps): JSX.Element {
  return <DesktopFeaturesPage path={location.pathname} />
}
